import styled from '@emotion/styled';
import { colors } from '@atlaskit/theme';

export const VerifiedEmailWrapper = styled.div`
  margin-top: 10px;
  color: ${colors.N800};
`;

export const BoldEmailWrapper = styled.p`
  font-weight: bold;
  overflow-wrap: break-word;
  margin: 0;
`;

export const VerifiedIconWrapper = styled.span`
  padding: 0 4px;
  color: ${colors.G400};
`;
